import React from 'react'
import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/pdf/Separator'
import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import { formatDollar, sumAmount } from '../../_helpers/pdfHelpers'

const Pricing = ({ hardwareData, softwareData, servicesData }) => {
  return (
    <>
      <Text bold size="h5">
        Pricing
      </Text>
      <Separator weight={5} />
      <Text semibold>
        <i>All deliverables are detailed in Delivery Schedules section lower in proposal</i>
      </Text>
      <Table width="100%" useFontBaseColor>
        <TableRow useFontBaseColor style={{ backgroundColor: '#ffe599' }}>
          <TableCol useFontBaseColor>
            <Text bold>Item</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Description</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Qty</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Term</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Unbundled</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>List Price</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Net Price</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Subtotal</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Tax</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Total</Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor style={{ backgroundColor: '#e7e6e6' }}>
          <TableCol useFontBaseColor colspan="10">
            <Text bold>A la Carte Hardware</Text>
          </TableCol>
        </TableRow>
        {hardwareData.map((item, index) => (
          <TableRow useFontBaseColor key={index}>
            <TableCol useFontBaseColor>
              <Text>{item.item}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.description}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.quantity}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.term}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.unbundled}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.listPrice}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.netPrice}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{formatDollar(item.subtotal)}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{formatDollar(item.tax)}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{formatDollar(item.total)}</Text>
            </TableCol>
          </TableRow>
        ))}
        <TableRow useFontBaseColor style={{ backgroundColor: '#e7e6e6' }}>
          <TableCol useFontBaseColor colspan="10">
            <Text bold>A la Carte Software</Text>
          </TableCol>
        </TableRow>
        {softwareData.map((item, index) => (
          <TableRow useFontBaseColor key={index}>
            <TableCol useFontBaseColor>
              <Text>{item.item}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.description}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.quantity}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.term}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.unbundled}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.listPrice}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.netPrice}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{formatDollar(item.subtotal)}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{formatDollar(item.tax)}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{formatDollar(item.total)}</Text>
            </TableCol>
          </TableRow>
        ))}
        <TableRow useFontBaseColor style={{ backgroundColor: '#e7e6e6' }}>
          <TableCol useFontBaseColor colspan="10">
            <Text bold>A la Carte Services</Text>
          </TableCol>
        </TableRow>
        {servicesData.map((item, index) => (
          <TableRow useFontBaseColor key={index}>
            <TableCol useFontBaseColor>
              <Text>{item.item}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.description}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.quantity}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.term}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.unbundled}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.listPrice}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.netPrice}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{formatDollar(item.subtotal)}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{formatDollar(item.tax)}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{formatDollar(item.total)}</Text>
            </TableCol>
          </TableRow>
        ))}
        <TableRow useFontBaseColor style={{ backgroundColor: '#e7e6e6' }}>
          <TableCol useFontBaseColor colspan="7">
            <Text bold>Total</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>{formatDollar(sumAmount([...hardwareData, ...softwareData, ...servicesData], 'subtotal'))}</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>{formatDollar(sumAmount([...hardwareData, ...softwareData, ...servicesData], 'tax'))}</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>{formatDollar(sumAmount([...hardwareData, ...softwareData, ...servicesData], 'total'))}</Text>
          </TableCol>
        </TableRow>
      </Table>
    </>
  )
}

export default Pricing
